module.exports = __webpack_public_path__ + "static/media/BG.61cf7687.png";